export default __webpack_public_path__ + "static/media/arrow_right_active.62938c47.PNG";